import ss from './styles.module.css';

export const GlobalSpinner = () => {
    return(
        <div className={ss.container}>
            <div className={ss.loader}></div>
        </div>
    )
}